import { lazy } from "react";
import {
  HOME_URL,
  Dynamo_URL,
  Blog_url,
  About_url,
  Privacy_url,
  Contact_url,
  ReturnRefund_url,
  Terms_url,
  PaymentFailed_url,
  PaymentSuccess_url,
  PaymentTest_url,
  AllBlogs_url,
  SEARCH_URL,
} from "../constants";

import Chat from "../components/chat/chat";
import Dynamo from "../pages/Dynamo";
import StudentsJourneyAdvanceFilter from "../pages/studentsJourneyAdvanceFilter";
import TeacherPublicPreview from "../pages/teacherPublicPreview/index.jsx";

// Lazy loaded components
const Home = lazy(() => import("../pages/Home"));
const NotFound = lazy(() => import("../pages/notFound"));
const UnAuthorized = lazy(() => import("../pages/unAuthorized"));
const BlogDetail = lazy(() => import("../pages/Blog"));
const AllBlogs = lazy(() => import("../pages/AllBlogs"));
const AboutPage = lazy(() => import("../pages/About"));
const PrivacyPage = lazy(() => import("../pages/Privacy"));
const ReturnRefundPage = lazy(() => import("../pages/Refund"));
const TermsConditionsPage = lazy(() => import("../pages/TermsAndConditions"));
const ContactPage = lazy(() => import("../pages/Contact"));
const PaymentFailedPage = lazy(() => import("../pages/payment-failed"));
const PaymentSuccessPage = lazy(() => import("../pages/payment-success"));
const PaymentTestPage = lazy(() => import("../pages/payment-test"));

export const generalRoutes = [
  {
    path: HOME_URL,
    component: Home,
    protected: "",
  },
  {
    path: "/teacherProfile/:id",
    component: TeacherPublicPreview,
  },
  {
    path: "/un-authorized",
    component: UnAuthorized,
    protected: "",
  },
  {
    path: "/not-found",
    component: NotFound,
    protected: "",
  },
  {
    path: "chat/:id",
    component: Chat,
    protected: "",
  },
  {
    path: Dynamo_URL,
    component: Dynamo,
    protected: "",
  },
  {
    path: `${About_url}`,
    component: AboutPage,
    protected: "",
  },
  {
    path: `${AllBlogs_url}`,
    component: AllBlogs,
    protected: "",
  },
  {
    path: `${Contact_url}`,
    component: ContactPage,
    protected: "",
  },
  {
    path: `${Privacy_url}`,
    component: PrivacyPage,
    protected: "",
  },
  {
    path: `${ReturnRefund_url}`,
    component: ReturnRefundPage,
    protected: "",
  },
  {
    path: `${Terms_url}`,
    component: TermsConditionsPage,
    protected: "",
  },
  {
    path: `${PaymentFailed_url}`,
    component: PaymentFailedPage,
    protected: "",
  },
  {
    path: `${PaymentSuccess_url}`,
    component: PaymentSuccessPage,
    protected: "",
  },
  {
    path: `${PaymentTest_url}`,
    component: PaymentTestPage,
    protected: "",
  },
  {
    path: `${Blog_url}/:id`,
    component: BlogDetail,
    protected: "",
  },
];

export const specialRoutes = [
  {
    path: "/student/findTeacher",
    component: StudentsJourneyAdvanceFilter,
  },
  {
    path: SEARCH_URL,
    component: StudentsJourneyAdvanceFilter,
  },
];
